import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    language_list: [],
    active_language: {
      language_code:"en",
      language_name:"English"
    }
  };
  
  const changeLanguageStateSlice = createSlice({
    name: 'language',
    initialState: initialState,
    reducers: {
      listLanguage: (state, action) => {
        state.language_list = action.payload
      },
      activeLanguage: (state,action) => {
        state.active_language= action.payload 
      }
    }
  });
  
  export const { listLanguage, activeLanguage } = changeLanguageStateSlice.actions;
  
  export default changeLanguageStateSlice.reducer;